var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-display-field"},[_c('default-widget-field',_vm._g(_vm._b({},'default-widget-field',_vm.defaultFieldProps,false),_vm.defaultFieldListeners)),_c('div',{staticClass:"flex-centerize"},[_c('img',{attrs:{"src":_vm.imageDisplayUrl}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }